import { useState } from 'react';
import { Constants } from '../../constants';
import { ApiErrorMessage } from '../../components/ErrorMessage';
import {
  ColumnDefinition,
  DataTable,
} from '../../components/common/DataTable/DataTable';
import { usePaymentLinks } from './paymentLinkQueries';
import { usePaymentLinkActions } from './usePaymentLinkActions';
import { PaymentLink } from '../../types/PaymentLink';

export interface PaymentLinkTableProps {
  filters: Metadata;
  header?: string;
  trackingContext: string;
}

export function PaymentLinkTable({
  filters,
  header,
  trackingContext,
}: PaymentLinkTableProps): JSX.Element {
  const [page, setPage] = useState(1);

  const { data, error, isLoading, refetch } = usePaymentLinks({
    page,
    per_page: Constants.LARGE_PAGE_SIZE,
    ...filters,
  });

  const { actions } = usePaymentLinkActions(trackingContext);

  const tableColumns: ColumnDefinition[] = [
    {
      field: 'created_at',
      type: 'date',
      headerName: 'Fecha de creación',
    },
    {
      field: 'name',
      type: 'string',
      headerName: 'Nombre',
    },
    {
      field: 'status',
      type: 'tag',
      headerName: 'Estado',
      tagType: 'paymentLink',
      tagLabel: (link: PaymentLink) => link.status,
    },
    {
      field: 'amount',
      type: 'currency',
      headerName: 'Monto',
      rightAligned: true,
    },
    {
      field: 'expiration_date',
      type: 'date',
      headerName: 'Fecha de vencimiento',
    },
    {
      field: 'uses',
      type: 'string',
      headerName: 'Usos',
      rightAligned: true,
    },
  ];

  const loadPage = (pageNumber: number) => setPage(pageNumber);

  const onErrorMessageClick = () => refetch();

  if (error) {
    return <ApiErrorMessage error={error} onClick={onErrorMessageClick} />;
  }

  const hasData = data?.data ? data?.data.length > 0 : false;

  return (
    <DataTable
      tableProps={{
        hasData,
        noDataMessage:
          'No se encontraron links de pago con los filtros aplicados',
      }}
      columns={tableColumns}
      pageSize={Constants.LARGE_PAGE_SIZE}
      isLoading={isLoading}
      rows={data?.data}
      menuActions={actions}
      rowBorder
      paginatorProps={{
        pages: data?.total_pages,
        selected: Number(data?.current_page),
        onSelectPage: loadPage,
      }}
      tableHeader={header}
    />
  );
}
